import * as React from 'react';
import MyTypes from 'MyTypes';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { Card, Spinner, Table } from 'react-bootstrap'; 
import plusIcon from '../../assets/images/Blue/add.svg';
import editIcon from '../../assets/images/Blue/edit.svg'; 
import * as models from '../../models';
import SingleActionButton from 'components/common/SingleActionButton';
import dateFormat from 'dateformat';
import * as companyActions from '../../store/companies/actions';
import CompanyFileTypeModal from './CompanyFileTypeModal';

interface Props extends PropsFromRedux {}

interface State {
    showModal: boolean;
    editingType: models.CompanyFileType | null;
}

class CompanyFileTypesTable extends React.Component<Props, State> {
    public state: State = {
        showModal: false,
        editingType: null
    };

    public componentDidMount() {
        this.props.requestCompanyFileTypes({ pageNo: 1, pageSize: 100 });
    }

    public handleAdd = () => {
        this.setState({ showModal: true, editingType: null });
    }

    public handleEdit = (type: models.CompanyFileType) => {
        this.setState({ showModal: true, editingType: type });
    }

    public render() {
        const { companyFileTypeResponse, isLoading } = this.props;

        return (
            <Card className="claim-card">
                <Card.Title>
                    Company File Types
                    {isLoading && <span>&nbsp;<Spinner animation="border" role="status" variant="primary" size="sm"/></span>}
                    <SingleActionButton
                        action="Add"
                        title="File Type"
                        img={plusIcon}
                        onClick={this.handleAdd}
                    />
                </Card.Title>

                {companyFileTypeResponse.totalCount > 0 && (
                    <Table striped hover responsive>
                        <thead>
                            <tr>
                                <th>Active</th>
                                <th>Type Name</th>
                                <th>Created Date</th>
                                <th>Created By</th>
                                <th style={{ width: '50px' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {companyFileTypeResponse.resourceList.map((x: models.CompanyFileType, i: number) => (
                                <tr key={i}>
                                    <td>{x.isActive ? "Yes" : "No"}</td>
                                    <td><strong>{x.name}</strong></td>
                                    <td>{x.createdDate ? dateFormat(x.createdDate, "mm/dd/yyyy") : ""}</td>
                                    <td>{x.createdBy}</td>
                                    <td>
                                        <SingleActionButton
                                            action="Edit"
                                            title="File Type"
                                            img={editIcon}
                                            onClick={() => this.handleEdit(x)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
                <CompanyFileTypeModal 
                    showModal={this.state.showModal} 
                    editingType={this.state.editingType} 
                    closeModal={() => this.setState({ showModal: false })} 
                /> 
            </Card>
        );
    }
}

const mapStateToProps = (state: MyTypes.RootState) => ({
    companyFileTypeResponse: state.companies.companyFileTypes.companyFileTypesList,
    isLoading: state.companies.companyFileTypes.isCompanyFileTypesLoading
});

const mapDispatchToProps = (dispatch: Dispatch) => 
    bindActionCreators(
        {
            requestCompanyFileTypes: companyActions.requestCompanyFileTypesList
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps); 
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(CompanyFileTypesTable);